import React from 'react';
import captureException from '../services/captureException';

interface EntityDefinitionsContextType {
  entityDefinitions: EntityDetails.Entity[];
  entityDetailsApps: EntityDetails.App[];
  // localUpdateOrAddApp -> prevent race conditions
  localUpdateOrAddApp: (app: EntityDetails.App) => void;
  isLoading: boolean;
  getEntityAndDefaultAppForField: ({
    field,
  }: {
    field: string;
  }) => { entity: EntityDetails.Entity; app: EntityDetails.App } | undefined;
  getEntityAndAppForSlug: ({
    slug,
  }: {
    slug: string;
  }) => { entity: EntityDetails.Entity; app: EntityDetails.App } | undefined;
}

const EntityDefinitionsContext =
  React.createContext<EntityDefinitionsContextType>({
    entityDefinitions: [],
    localUpdateOrAddApp: () => {
      const e = new Error();
      e.name = 'localUpdateOrAddApp is not defined';
      captureException(e);

      return undefined;
    },
    entityDetailsApps: [],
    isLoading: true,
    getEntityAndAppForSlug: () => {
      if (process.env.NODE_ENV === 'test') {
        return undefined;
      }

      const e = new Error();
      e.name =
        'EntityDefinitionsContext: getEntityAndAppForSlug is not defined';
      captureException(e);
      throw e;
    },
    getEntityAndDefaultAppForField: () => {
      if (process.env.NODE_ENV === 'test') {
        return undefined;
      }

      const e = new Error();
      e.name =
        'EntityDefinitionsContext: getEntityAndDefaultAppForField is not defined';
      captureException(e);
      throw e;
    },
  });

export default EntityDefinitionsContext;
